import { Component, cloneElement } from 'react'

export default class ComponentStyle extends Component {
  constructor (props) {
    super(props)

    this.Margin = {
      None: '',
      Extra_Small: 'mt-1',
      Small: 'mt-2',
      Medium: 'mt-3',
      Large: 'mt-4',
      Extra_Large: 'mt-5',
      Extra_Extra_Large: 'mt-6',
      Extra_Extra_Extra_Large: 'mt-7'
    }

    this.TextAlignment = {
      Left: 'text-start',
      Center: 'text-center',
      Right: 'text-end'
    }

    this.Background = {
      Transparent: 'bg-transparent text-dark',
      White: 'bg-white text-dark',
      Primary: 'bg-primary text-white'
    }

    this.Width = {
      Default: 'rounded',
      Full_Width: 'cms--full-width'
    }

    this.FontSize = {
      Extra_Small: 'fs-5',
      Small: 'fs-4',
      Medium: 'fs-3',
      Large: 'fs-2',
      Extra_Large: 'fs-1'
    }

    this.Size = {
      Small: 'btn-sm',
      Normal: '',
      Large: 'btn-lg',
      Extra_Large: 'btn-xl',
      Extra_Extra_Large: 'btn-xxl'
    }
  }

  getClassName () {
    return Object.keys(this.props.config)
      .filter(key => this[key])
      .map(key => {
        // The pattern from Stripe is always: { Margin: { Margin: 'None' } }
        const styleValue = this.props.config[key]

        if (!styleValue) return ''

        const supportedStyleValue = this[key][styleValue[key]]

        return supportedStyleValue || ''
      })
      .filter(style => style)
      .join(' ')
  }

  render () {
    return cloneElement(this.props.children, {
      className: `${this.props.children.props.className} ${this.getClassName()}`
    })
  }
}
